import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
      isAuthenticated: false,
      user: null
  },
  getters: {
      isAuthenticated(state) {
          return state.isAuthenticated;
      },
      user(state) {
          return state.user;
      }
  },
  mutations: {
      authStateChanged(state, isLoggedIn) {
          state.isAuthenticated = isLoggedIn;
      },
      userChanged(state, user) {
          state.user = user;
      }
  },
  actions: {
      authStateChanged({ commit }, loggedInWrapper) {
          commit('authStateChanged', loggedInWrapper.loggedIn);
      },
      userChanged({ commit }, user) {
          commit('userChanged', user);
      }
  },
  modules: {}
});
